import { observer } from 'mobx-react';
import * as React from 'react';
import { SaveDialog } from 'ui-toolkit';
import { IRecordedDeedRequired, IRecordedDeed } from '../classes/RecordedDeed';
import getText from '../utils/getText';
import EditModalWindow from './EditModalWindow';
import ExistingRecordedDeed from './ExistingRecordedDeed';
import RecordedDeedBlock from './RecordedDeedBlock';
import RecordedDeedEdit from './RecordedDeedEdit';

interface IRecordedDeedDetailsProps {
  data: IRecordedDeed;
  userData: IRecordedDeed;
  onRecordedDeedChange: (value: IRecordedDeed, propName: string, error?: string | null) => void;
  errorRecordedDeed: any;
  requiredFields: IRecordedDeedRequired;
  onUpdateDocument: () => void;
  onCancelClick: () => void;
  showSaveSpinner: boolean;
  showSaveSuccess: boolean;
  updateErrorText: string | null;
  recordedDeedReadyForSave: boolean;
}

interface IRecordedDeedDetailsState {
  modalWindowTitle: string;
  showEditRecordedDeed: boolean;
  showSaveDialog: boolean;
}

class RecordedDeedDetails extends React.Component<IRecordedDeedDetailsProps, IRecordedDeedDetailsState> {
  public readonly state: IRecordedDeedDetailsState = {
    modalWindowTitle: getText('recordedDeed.editNew'),
    showEditRecordedDeed: false,
    showSaveDialog: false,
  };

  public componentWillReceiveProps(newProps: IRecordedDeedDetailsProps) {
    // close edit modal window after save changes
    if (this.state.showEditRecordedDeed && this.props.showSaveSuccess && !newProps.showSaveSuccess) {
      this.toggleEditWindow();
    }
    // open saveDialog if an error
    if (!this.props.updateErrorText && newProps.updateErrorText && this.state.showEditRecordedDeed) {
      this.toggleSaveDialog();
    }
  }

  public render() {
    return (
      <>
        {this.props.data.existing ? (
          <ExistingRecordedDeed data={this.props.data} onEditClick={this.toggleEditWindow} />
        ) : (
          <RecordedDeedBlock data={this.props.data} onEditClick={this.toggleEditWindow} />
        )}

        {this.state.showEditRecordedDeed ? (
          <EditModalWindow
            title={this.state.modalWindowTitle}
            showSaveSpinner={this.props.showSaveSpinner}
            showSaveSuccess={this.props.showSaveSuccess}
            disableUpdateButton={this.props.recordedDeedReadyForSave}
            onUpdateDocument={this.onUpdateDocument}
            onClose={this.onCancelClick}
          >
            <RecordedDeedEdit
              data={this.props.userData}
              requiredFields={this.props.requiredFields}
              errorRecordedDeed={this.props.errorRecordedDeed}
              onRecordedDeedChange={this.props.onRecordedDeedChange}
            />
          </EditModalWindow>
        ) : null}

        {this.state.showSaveDialog ? (
          <SaveDialog
            errorMessage={this.props.updateErrorText || ''}
            showSaveSpinner={this.props.showSaveSpinner}
            showSaveSuccess={this.props.showSaveSuccess}
            onYesClick={this.onUpdateDocument}
            onNoClick={this.toggleSaveDialog}
          />
        ) : null}
      </>
    );
  }

  private toggleEditWindow = (title?: string) => {
    this.setState((state) => ({
      modalWindowTitle: title ? title : state.modalWindowTitle,
      showEditRecordedDeed: !state.showEditRecordedDeed,
    }));
  };

  private toggleSaveDialog = () => {
    this.setState((state) => ({
      showSaveDialog: !state.showSaveDialog,
    }));
  };

  private onCancelClick = () => {
    this.props.onCancelClick();
    this.toggleEditWindow();
  };

  private onUpdateDocument = () => {
    if (this.props.recordedDeedReadyForSave) {
      this.props.onUpdateDocument();
    }
  };
}

export default observer(RecordedDeedDetails);
